import { queryCustomerId, user } from '../../../utils/initValues'
import settings from '../../components/settings'

export const useMyProjectCustomer = () =>
  fetch(
    `${settings.badaAppointmentApiUrl}/customer/?brand=${settings.brand}&customerId=${queryCustomerId || ''}`,
    {
      method: 'GET',
      headers: {
        'Content-Type': 'application/json',
        Authorization: user.access_token
          ? `Bearer ${user.access_token}`
          : undefined,
      },
    }
  ).then((r) => r.json())
